<template>
  <div class="nft-ntfc-view">
    <bottom-slide-sheet v-model:visible="isOpen" title="receiveNtfc.title" @cancel="onOk">
      <template #content>
        <receive-nft-comp
          v-if="info.type === 'NFT_RECEIVE'"
          :info="(info as NtfcNftReceiveResponse)"
          @ok="onOk"
        />
        <UserInviteComp
          v-else-if="info.type === 'USER_INVITE'"
          :info="(info as NtfcUserInviteResponse)"
          @ok="onOk"
        />
        <SaleCpltComp
          v-else-if="info.type === 'NFT_SELL'"
          :info="info"
          @ok="onOk"
        />
      </template>
    </bottom-slide-sheet>
  </div>
</template>

<script lang="ts">
import {defineComponent, watch, ref} from 'vue';
import { useNftNtfc } from '@/script/ntfc/ntfcScript';
import { useModal } from '@/script/common/modalScript';
import BottomSlideSheet from '@/components/common/modal/BottomSlideSheet.vue';
import ReceiveNftComp from '@/components/pages/popup/comp/ReceiveNftComp.vue';
import UserInviteComp from '@/components/pages/popup/comp/UserInviteComp.vue';
import SaleCpltComp from '@/components/pages/popup/comp/SaleCpltComp.vue';
import { store } from '@/store';
import {
  NtfcNftReceiveResponse,
  NtfcUserInviteResponse,
} from '@/models/response/ntfcResponseModel';
import {onBeforeRouteUpdate, useRoute, useRouter} from 'vue-router';

export default defineComponent({
  name: 'NftNtfcView',
  components: { BottomSlideSheet, ReceiveNftComp, UserInviteComp, SaleCpltComp },
  setup() {
    const route = useRoute()
    const router = useRouter()
    const { isOpen, toggleModal } = useModal();
    const { list, info, getNtfcList, getNtfc } = useNftNtfc();
    const interval = ref()
    const count = ref(0)
    const startPolling = () => {
      interval.value = setInterval(async () => {
        try {
          if (store.state.auth.id) {
            try {
              await getNtfcList();
            } catch(e: any) {
              console.error(e)
              if (e?.response?.status === 401) {
                clearInterval(interval.value);
              }
            }
          }
          count.value += 1
          if (list.value.length > 0) {
            await getNtfc(Number(list.value.pop()));
            toggleModal(true);
            clearInterval(interval.value);
          }
          if (count.value >= 1) {
            clearInterval(interval.value)
          }
        } catch (e: any) {
          clearInterval(interval.value);
        }
      }, 1000);
    };

    watch(() => route.name, (next) => {
      if (next === 'HomeView') {
        startPolling();
      } else {
        clearInterval(interval.value)
      }
    })

    const onOk = async () => {
      toggleModal(false);
      if (list.value.length > 0) {
        await getNtfc(Number(list.value.pop()));
        toggleModal(true);
      } else {
        if (['NFT_RECEIVE', 'NFT_SELL'].includes(info.value.type) && route.name === 'HomeView') {
          store.state.status.nftList.refreshWait = true
        }
        toggleModal(false);
        startPolling();
      }
    };

    return { list, isOpen, info, onOk };
  },
});
</script>
